import { Navigate, Route, Routes } from 'react-router-dom'
import FieldConfigPage from './pages/FieldConfigPage'
import AnonymizationStatusPage from './pages/AnonymizationStatusPage'
import ImportCreditAppPage from './pages/ImportCreditAppPage'

const AnonymizerRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<FieldConfigPage />} />
      <Route path="/status" element={<AnonymizationStatusPage />} />
      <Route path="/import" element={<ImportCreditAppPage />} />
      <Route path="*" element={<Navigate to="/anonymizer" replace />} />
    </Routes>
  )
}

export default AnonymizerRoutes
